import { Popover } from 'antd';
import { TPODataContext } from 'contexts/TPOContext';
import { FC, useContext, useState } from 'react';
import { PopUpErrorObject } from 'types/tradePromoOptimization';

type Props = {
    promoPopupErrors: PopUpErrorObject[];
    errorIcon?: React.ReactNode;
    disableErrorCount?: boolean;
    headerClassName?: string;
};
export default function ErrorPopover({
    promoPopupErrors,
    errorIcon,
    disableErrorCount,
    headerClassName = 'text-redAlt',
}: Props) {
    const [open, setOpen] = useState(false);

    const content = (
        <div className="max-h-[300px] w-[300px] overflow-y-auto bg-backgroundGreyAlt p-2 rounded-xl pr-2">
            {promoPopupErrors.map((group, idx) => (
                <div
                    key={idx}
                    className={`mb-2 pb-2 border-borderGreyAl1 ${
                        idx < promoPopupErrors.length - 1 ? 'border-b ' : ''
                    }  `}
                >
                    <div className={`${headerClassName}`}>{group.title}</div>
                    {group.description.map((msg, i) => (
                        <div key={i} className={`opacity-70 pb-1 mb-1`}>
                            {msg}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );

    // Total number of individual errors
    const errorCount = promoPopupErrors.reduce((count, group) => count + group.description.length, 0);

    return (
        <div>
            <Popover
                content={content}
                title={false}
                trigger="click"
                open={open}
                onOpenChange={(visible) => setOpen(visible)}
                placement="bottomLeft"
            >
                <div className="flex gap-1 items-center">
                    {errorIcon && errorIcon}
                    {!disableErrorCount && (
                        <div className="text-redAlt flex gap-1 items-center cursor-pointer underline">
                            <span className="ml-1 ">{errorCount}</span>
                            <span>Error(s)</span>
                        </div>
                    )}
                </div>
            </Popover>
        </div>
    );
}
